<template>
  <el-dialog
    :title="title"
    :append-modelody="true"
    :modal-append-to-body="false"
    width="580px"
    :visible="dialogVisible"
    @close="onCancel"
    class="btn-close"
  >
    <div class="inner-box">
      <div class="item" @click="companyHandler()">
        <div class="logo"><i class="iconfont icongongsi1"></i></div>
        <div class="title">我是企业/机构</div>
        <div class="info">我要安排一场考试</div>
      </div>
      <div class="item" @click="singleHandler()">
        <div class="logo"><i class="iconfont iconyonghu"></i></div>
        <div class="title">我是个人</div>
        <div class="info">我是参加考试</div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: ['dialogVisible', 'title'],
  components: {},
  mounted() {},
  methods: {
    onCancel() {
      this.$emit('onCancel')
    },
    companyHandler() {
      this.$cookies.set('role',1, 60 * 60 * 12)
      this.$emit('companyHandler')
    },
    singleHandler() {
      this.$emit('singleHandler')
    },
  },
}
</script>
<style lang="scss" scoped>
.inner-box {
  display: flex;
  padding: 20px 48px 40px;
  text-align: center;
  .item {
    text-align: center;
    font-weight: 300;
    border: 1px solid #29bdb9;
    margin-right: 20px;
    padding: 30px 20px;
    border-radius: 4px;
    width: 200px;
    cursor: pointer;
    &:last-child {
      margin-right: 0px;
    }
    &:hover {
      background: #29bdb9;
      color: #fff;
      .title,
      .logo {
        color: #fff;
      }
    }
    .logo {
      width: 100%;
      color: #29bdb9;
      .iconfont {
        font-size: 50px;
      }
    }
    .title {
      font-size: 24px;
      width: 100%;
      padding: 20px 0px;
      color: #29bdb9;
    }
    .info {
      font-size: 16px;
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dialog/trial-dialog.vue